/** @graphql cc **/
import gql from 'graphql-tag';

import { getApolloClient } from '@confluence/graphql';

import {
	SitePermissionType,
	type fetchPresenceConfluenceUsersQuery as UsersQuery$data,
	type fetchPresenceConfluenceUsersQueryVariables as UsersQuery$variables,
} from './__types__/FetchPresenceConfluenceUsersQuery';

export const fetchPresenceConfluenceUsers = (accountIds: string[]) => {
	return getApolloClient()
		.query<UsersQuery$data, UsersQuery$variables>({
			query: gql`
				query fetchPresenceConfluenceUsersQuery($accountIds: [String]) {
					confluenceUsers(accountIds: $accountIds) {
						nodes {
							profilePicture {
								isDefault
								path(type: RELATIVE)
							}
							... on KnownUser {
								accountId
							}
							... on UnknownUser {
								accountId
							}
							displayName
							permissionType
						}
					}
				}
			`,
			variables: { accountIds },
		})
		.then(({ data }) => {
			return (
				data?.confluenceUsers?.nodes
					?.filter((user) => (user as any)?.accountId)
					.map((user) => ({
						avatar: user?.profilePicture?.path ?? '',
						email: '',
						isGuest: user?.permissionType === SitePermissionType.EXTERNAL ?? undefined,
						name: user?.displayName ?? '',
						userId: (user as any)?.accountId ?? '',
					})) ?? []
			);
		});
};
